require('./lbLoadingPlaceholder.scss');

const $inject = [];

const lbLoadingPlaceholderItem = {
  template: require('./lbLoadingPlaceholderItem.html'),
  controller: 'lbLoadingPlaceholderItemCtrl',
  controllerAs: 'vm',
  bindings: {
    total: '<',
    isHeading: '<',
    maxWidth: '<',
    minWidth: '<',
    width: '<',
    size: '<'
  }
};

lbLoadingPlaceholderItem.$inject = $inject;

export default lbLoadingPlaceholderItem;




// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.js